import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import { ParagraphArticleFiltered as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphArticlesFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphArticlesFiltered: React.FC<ParagraphArticlesFilteredProps> = ({ entity }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const themeTargetId = urlParams.get('field_themes_target_id');
  const paragraph = entity.toJS();
  const articleTypeId = paragraph.field_article_type[0]?.target_id || null;

  const defaultFilters = {
    field_themes_target_id: themeTargetId,
    field_article_type_target_id: articleTypeId,
  };

  return (
    <div className="ParagraphArticlesFiltered">
      <View
        classes="ViewArticlesFiltered"
        id="articles_filtered"
        display="articles_filtered"
        defaultFilterValues={defaultFilters}
        hideFilters={articleTypeId !== null}
        withProvider
      />
    </div>
  );
};

export default ParagraphArticlesFiltered;
